import script from "./SHService.vue?vue&type=script&setup=true&lang=ts"
export * from "./SHService.vue?vue&type=script&setup=true&lang=ts"

import "./SHService.vue?vue&type=style&index=0&id=77c8dae6&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c8dae6"]])

export default __exports__